if( document.querySelector('#wpadminbar') ) {
    import('./admin_bar');
}